/*
 * @Author: 肖玲
 * @Date: 2023-02-15 17:08:23
 * @LastEditTime: 2023-02-16 11:17:47
 * @LastEditors: 肖玲
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\business-order\order-manage\modules\cooperativeManageRouter.js
 * 合作管理
 */
const cooperativeManagementRouter = [
  // 购销合同管理
  {
    path: '/orderSystem/contract-list',
    name: 'orderSystemContractPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"agreement" */
      //   '@/views/orderSystem/contract/Page'
      // ),
      import(
        /*webpackChunkName:"agreement" */
        '@/views/business-order/order-manage/cooperative-manage/purchase-sales-manage/Page.vue'
      ), // 新迁移文件
    meta: {
      SecondaryMenu: '合作管理', //二级菜单
      title: '购销合同管理',
    },
  },
  // 购销合同详情
  {
    path: '/orderSystem/contract-detail/:order_contract_id',
    name: 'orderSystemContractDetail',
    component: () =>
      import(
        /*webpackChunkName:"agreement" */
        '@/views/orderSystem/contract/Detail'
      ),
      // import(
      //   /*webpackChunkName:"agreement" */
      //   '@/views/business-order/order-manage/cooperative-manage/purchase-sales-manage/Detail.vue'
      // ), 新迁移文件
    meta: {
      SecondaryMenu: '合作管理', //二级菜单
      title: '购销合同详情',
      breadcrumb: [{
        title: '购销合同管理',
        name: 'orderSystemContractPage',
      }, ],
    },
  },
  // 购销合同添加编辑 meta_type 1新增 2编辑 from 1-列表 2-详情
  {
    path: '/orderSystem/contract-edit/:meta_type/:order_contract_id/:from',
    name: 'orderSystemContractEdit',
    component: () =>
      import(
        /*webpackChunkName:"agreement" */
        '@/views/orderSystem/contract/Edit'
      ),
      // import(
      //   /*webpackChunkName:"agreement" */
      //   '@/views/business-order/order-manage/cooperative-manage/purchase-sales-manage/AddEdit.vue'
      // ),  新迁移文件
    meta: {
      SecondaryMenu: '合作管理', //二级菜单
      isMoreMeta: true,
      1: {
        title: '新增购销合同',
        breadcrumb: [{
            title: '购销合同管理',
            name: 'orderSystemContractPage',
          },
          {
            title: '购销合同详情',
            name: 'orderSystemContractDetail',
          },
        ],
      },
      2: {
        title: '编辑购销合同',
        breadcrumb: [{
            title: '购销合同管理',
            name: 'orderSystemContractPage',
          },
          {
            title: '购销合同详情',
            name: 'orderSystemContractDetail',
          },
        ],
      },
    },
  },
]
export default cooperativeManagementRouter